import { fetchApi } from "@/lib/api";
import { useMutation } from "@tanstack/react-query";

interface SaveHomescreenImageParams {
  messageId: string;
  teenId: string;
}

interface SaveHomescreenImageResponse {
  success: boolean;
  id: string;
}

const saveHomescreenImage = async ({
  messageId,
  teenId,
}: SaveHomescreenImageParams) => {
  const response = await fetchApi<SaveHomescreenImageResponse>({
    url: "v2/homescreen-images",
    method: "POST",
    data: {
      message_id: messageId,
      teen_id: teenId,
    },
  });

  return response.data;
};

export const useSaveHomescreenImage = () => {
  return useMutation({
    mutationFn: saveHomescreenImage,
  });
};
